module.exports = __webpack_public_path__ + "media/Hörbuch.d7dfa34c.mp3";